import { manualProductionEntryActionTypes } from '@Actions/production/manualProductionEntryActions';

const ManualProductionEntryReducers = (state = {}, action) => {
  switch (action.type) {
    case manualProductionEntryActionTypes.GET_MANUAL_PRODUCTION_ENTRIES.LOADING: {
      const { getManualProductionEntryLoading } = action;
      return {
        ...state,
        getManualProductionEntryLoading,
      };
    }
    case manualProductionEntryActionTypes.GET_MANUAL_PRODUCTION_ENTRIES.SUCCESS: {
      const { manualProductionEntries } = action;
      return {
        ...state,
        manualProductionEntries,
      };
    }
    case manualProductionEntryActionTypes.GET_MANUAL_PRODUCTION_ENTRY_BY_ID.LOADING: {
      const { getManualProductionEntryByIdLoading } = action;
      return {
        ...state,
        getManualProductionEntryByIdLoading,
      };
    }
    case manualProductionEntryActionTypes.GET_MANUAL_PRODUCTION_ENTRY_BY_ID.SUCCESS: {
      const { selectedManualProductionEntry } = action;
      return {
        ...state,
        selectedManualProductionEntry,
      };
    }
    case manualProductionEntryActionTypes.CREATE_MANUAL_PRODUCTION_ENTRY.LOADING: {
      const { createManualProductionEntryLoading } = action;
      return {
        ...state,
        createManualProductionEntryLoading,
      };
    }
    case manualProductionEntryActionTypes.UPDATE_MANUAL_PRODUCTION_ENTRY_STATUS.LOADING: {
      const { updateManualProductionEntryStatusLoading } = action;
      return {
        ...state,
        updateManualProductionEntryStatusLoading,
      };
    }
    case manualProductionEntryActionTypes.DELETE_MANUAL_PRODUCTION_ENTRY.LOADING: {
      const { deleteManualProductionEntryLoading } = action;
      return {
        ...state,
        deleteManualProductionEntryLoading,
      };
    } default: {
      return state;
    }
  }
}

export default ManualProductionEntryReducers;